import { create } from "zustand";

interface SheetState {
  isOpen: boolean;
  currentAppInView?: string;
  setCurrentAppInView: (appId: string) => void;
  openHelp: () => void;
  closeHelp: () => void;
}

// Create Zustand store
export const useAmplitudeHelpStore = create<SheetState>((set, get) => ({
  isOpen: false,
  currentAppInView: undefined,
  setCurrentAppInView: (appId: string) => set({ currentAppInView: appId }),
  openHelp: () => {
    set({ isOpen: true });
  },
  closeHelp: () => {
    set({ isOpen: false});
  },
}));
